{
  "fr": {
    "partners": {
      "headings": {
        "course": "Continuez à vous former avec {partner}",
        "description": "C'est pourquoi nous recommandons {partner} :",
        "emptyState": "Malheureusement, aucune entrée de partenaire n'a été trouvée.",
        "feedback": "Votre outil préféré manque-t-il ou souhaitez-vous recommander une application ?",
        "materials": "Découvrez les matériaux de {partner}",
        "subtitle": "Que souhaitez-vous utiliser aujourd'hui ?",
        "title": "Découvrez des partenaires éducatifs sélectionnés"
      },
      "hints": {
        "notPublished": "Ce partenaire n'est pas encore publié. Visible uniquement pour les admins. 😎"
      },
      "links": {
        "breadCrumbIndex": "Aperçu des partenaires",
        "login": "Se connecter",
        "loginWithFobizz": "Connectez-vous maintenant avec fobizz",
        "registerWithFobizz": "Essayez maintenant avec fobizz",
        "sendFeedback": "N'hésitez pas à nous envoyer un e-mail à"
      }
    }
  }
}
